export default "__VITE_ASSET__00582b5e__"